<template>
  <div v-if="!isTrackerExpired" :class="colorTheme">
    <div class="loading" v-if="loading">
      <v-progress-circular :indeterminate="true"/>
    </div>
    <div v-else>
      <estimated-arrival/>
      <service-map/>
      <div class="pull">
        <div></div>
      </div>
      <user-profile/>
      <user-bio/>
      <div class="divider"></div>
      <review-highlights/>
    </div>
  </div>
  <tracker-expired v-else/>
</template>

<script>
  import EstimatedArrival from "../components/EstimatedArrival";
  import ServiceMap from "../components/ServiceMap";
  import UserProfile from "../components/UserProfile";
  import TrackerExpired from "../components/TrackerExpired";
  import UserBio from "../components/UserBio";
  import ReviewHighlights from "../components/ReviewHighlights";

  export default {
    name: "Tracker",
    components: {
      ReviewHighlights,
      UserBio,
      TrackerExpired,
      UserProfile,
      ServiceMap,
      EstimatedArrival,
    },
    created() {
      if (!this.$route.query.token) {
        this.$router.push('/notfound');
      }
      this.$store.dispatch('setToken', {
        token: this.$route.query.token,
      });
      this.$store.dispatch('loadTracker', {
        token: this.$route.query.token
      });
    },
    computed: {
      loading() {
        return this.$store.getters.findingTracker;
      },
      isTrackerExpired() {
        return this.$store.getters.isTrackerExpired;
      },
      colorTheme() {
        return this.$store.getters.colorTheme;
      },
    },
  }
</script>

<style lang="scss" scoped>
  .divider {
    border: 3px solid var(--divider);
  }

  .pull {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;

    div {
      width: 50px;
      height: 5px;
      background-color: var(--divider);
      border-radius: 4px;
    }

  }

  .loading {
    height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
